import StateSelect from 'src/components/Selects/StateSelect'

import { State } from '../../../../types/graphql'
import { TanstackField } from '../../../utils/forms'

type Props<TKey extends string> = {
  field: TanstackField<State | null | undefined, TKey>
  isRequired?: boolean
  label?: React.ReactNode
}
const StateSelectField = <TKey extends string>({ field, isRequired, label }: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  return (
    <StateSelect
      errorMessage={errorMessage}
      isInvalid={!!errorMessage}
      isRequired={isRequired}
      label={label}
      onBlur={field.handleBlur}
      onValueChange={field.setValue}
      value={field.state.value}
    />
  )
}

export default StateSelectField
